module.exports = __webpack_public_path__ + "75dd7621366b8ee65aa2a05bd06eae2c.png";